import { DocumentoDTO } from "./documentoDTO";
import { RiferimentiPosizioneDTO } from "./riferimento-posizioneDTO";
import { ClassificaDTO } from "./classificaDTO";
import { TempiConservazioneDTO } from "./tempi-conservazioneDTO";
import { TipoSupportoDocumentoEnum } from "../enum/tipo-supporto-documento-enum";
import { StrutturaFascicoloDTO } from "./struttura-fascicoloDTO";
import { MetadatiProtocolloDTO } from "./metadati-protocolloDTO";
import { VisibilitaFascicoloDTO } from "./visibilita-fascicoloDTO";
import { UtenteDTO } from "./utenteDTO";
import { MetadatiRepertorioDTO } from "./metadati-repertorioDTO";
import { MetadatiFascicoloDTO } from "./metadati-fascicoloDTO";
import { LinguaDTO } from "./linguaDTO";
import { DatiReportorioManualiDTO } from "./dati-repertorio-manualiDTO";
import { SettoreDTO } from "./settoreDTO";
import { DatiPersonaliDTO } from "./dati-personaliDTO";

export class UnitaDocumentariaDTO {
  id: string;

  tipo: TipoSupportoDocumentoEnum;

  stato: string;

  oggetto: string;

  segnaturaArchivistica: string;

  primario: DocumentoDTO;

  numeroDocCartacei: string;

  descDocumentiCartacei: string;

  riferimentoPosizione: RiferimentiPosizioneDTO;

  classifica: ClassificaDTO;

  classificaAggiuntiva: ClassificaDTO;

  tempiConservazione: TempiConservazioneDTO; //ereditabile da fascicolo o tipologia di documento primario ma modificabile

  protocollato: boolean;

  repertoriato: boolean;

  struttura: StrutturaFascicoloDTO;

  allegati: DocumentoDTO[];

  inseritoDa: UtenteDTO;
  //  riservato: boolean;
  collocazioneFisica: string;

  dataUltimaModifica: string;

  dataInserimentoFascicolo: string;

  dataArchiviazione: string;

  dataInserimento: string;

  metadatiProtocollo: MetadatiProtocolloDTO[];

  metadatiRepertorio: DatiReportorioManualiDTO;

  visibilitaElemento: VisibilitaFascicoloDTO[] = new Array<
    VisibilitaFascicoloDTO
  >();

  importDaGescor: boolean;

  isArrivo: boolean;

  importata: boolean;

  bloccatoDa: UtenteDTO;

  idCorrispondenza: string;

  idAttribuzione: string;

  metadatiFascicolo: MetadatiFascicoloDTO;

  personale: boolean;

  copiaUd: Boolean;

  idCopia: string;

  lingue: LinguaDTO[];

  altraDenominazione: string;

  dimensioni: number;

  struttureAggiuntive: SettoreDTO[];

  privato: boolean;

  datiPersonali: DatiPersonaliDTO;

  riservato: boolean;

  inFirma: Boolean;
}
